import React from "react";

import strings from "../../helpers/Localization";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import IconComponent from "../Icons/IconComponent";
import Loader from "../Loader/Loader";
import ButtonSKA from "../Buttons/ButtonSKA";
import TextField from "../Inputs/TextField";
import Dropdown from "../Inputs/Dropdown";
import ChooseTags from "../Tags/ChooseTags";
import Switch from "../Switch/Switch";
import ButtonSkaRound from "../Buttons/ButtonSkaRound";
import Toggle from "../Inputs/Toggle";

const NoResults = ({ tableManager }) => {
    return <div className="TextContent16" style={{ flexGrow: "1", textAlign: "center", width: "100%", marginTop: "20px", marginBottom: "20px" }}>
        {strings.noItems}
    </div>;
};

const PaginationList = ({ pageSize, forcePaginationUpdate, updateRowOnChange, onGetElements, onSavePagination, myElements, filterOptions, sortOptions, cardElement, tableElement, tags, shrink, isInModal, icon, title, headerButton, headerInfo, headerToggle, onClose, forceLoading }) => {
    const parseTagSearchExpression = (tagSearchExpression) => {
        if (tagSearchExpression && tagSearchExpression !== "") {
            const var1 = tagSearchExpression.split("&");
            const stags = [];
            var1.forEach(exp => {
                const spl = exp.split("=");
                if (spl[0] === "tagIdList") {stags.push(tags.find(td => td.id.toString() === spl[1].toString()));}
            });
            return stags;
        }
        return [];
    };

    const [paginationType, setPaginationType] = React.useState(() => {
        const fallback = tableElement
            ? { sort: null, columns: tableElement(null).map((te, teindex) => ({ position: teindex, teindex, forcedwidth: null })) }
            : { sort: null, columns: [] };

        const val = myElements && myElements.PaginationType;

        if (val == null) {return fallback;}
        if (typeof val === "object") {return val;} // Already parsed
        if (typeof val === "string") {
            try {
                return JSON.parse(val);
            }
            catch {
                return fallback;
            }
        }
        return fallback;
    });

    const [showCards, setShowCards] = React.useState(false);
    const [parsedFilterExpression, setParsedFilterExpression] = React.useState({});
    const [parsedSortExpression, setParsedSortExpression] = React.useState(paginationType && paginationType.sort ? paginationType.sort : sortOptions ? sortOptions : []);
    const [parsedTagsExpression, setParsedTagsExpression] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [tpageSize, setPageSize] = React.useState(pageSize ? pageSize : 50);
    const [currentPage, setCurrentPage] = React.useState(myElements && myElements.currentPage ? myElements.currentPage : 1);
    const [sortExpression, setSortExpression] = React.useState(myElements && myElements.sortExpression ? myElements.sortExpression : null);
    const [filterExpression, setFilterExpression] = React.useState(myElements && myElements.filterExpression ? myElements.filterExpression : "");
    const [tagExpression, setTagsExpression] = React.useState(myElements && myElements.tagSearchRequest ? parseTagSearchExpression(myElements.tagSearchRequest) : "");
    const [textfieldPage, setTextFieldPage] = React.useState(myElements && myElements.currentPage ? myElements.currentPage : 1);
    const [bottomPagination, setBottomPagination] = React.useState(myElements && myElements.results && myElements.results.length > 0 ? {
        currentPage: myElements.currentPage ? myElements.currentPage : 1,
        pageCount: myElements.pageCount ? myElements.pageCount : 1
    } : null);
    const [tableRows, setTableRows] = React.useState([]);
    const [tableColumns, setTableColumns] = React.useState([]);

    const tableWrapRef = React.useRef(null);



    // For change width of columns
    React.useEffect(() => {
        const root = tableWrapRef.current;
        if (!root) {return;}

        const line = document.createElement("div");
        line.style.position = "absolute";
        line.style.top = "0";
        line.style.bottom = "0";
        line.style.width = "2px";
        line.style.background = "var(--grey-light)";
        line.style.pointerEvents = "none";
        line.style.zIndex = "9999";
        line.style.display = "none";
        root.appendChild(line);

        let dragging = false;

        const onMouseDown = (e) => {
            const target = e.target;
            if (!(target instanceof HTMLElement)) {return;}
            if (!target.classList.contains("p-column-resizer")) {return;}

            dragging = true;
            line.style.display = "block";

            const rootRect = root.getBoundingClientRect();
            const scroller
      = root.querySelector(".p-datatable-wrapper")
      || root.querySelector(".p-datatable-scrollable-body")
      || root;

            const onMove = (ev) => {

                const NUDGE = 40; // Shift for mouse position
                if (!dragging) {return;}

                const scrollLeft = scroller instanceof HTMLElement ? scroller.scrollLeft : 0;

                // mouse position relative to root + scroll horizontal for move column
                const x = ev.clientX - rootRect.left + scrollLeft;
                line.style.left = `${x}px`;
            };

            const onUp = () => {
                dragging = false;
                line.style.display = "none";
                window.removeEventListener("mousemove", onMove);
                window.removeEventListener("mouseup", onUp);
            };

            window.addEventListener("mousemove", onMove);
            window.addEventListener("mouseup", onUp);
        };

        root.addEventListener("mousedown", onMouseDown);

        return () => {
            root.removeEventListener("mousedown", onMouseDown);
            root.removeChild(line);
        };
    }, []);



    const tableSort = React.useMemo(() => {
        if (!Array.isArray(parsedSortExpression) || !Array.isArray(tableColumns)) {return null;}

        const sortIndex = parsedSortExpression.findIndex(
            (se) => se.sortData === "asc" || se.sortData === "desc"
        );
        if (sortIndex < 0) {return null;}

        const column = tableColumns.find((tc) => tc.sortIndex === sortIndex);
        if (!column) {return null;}

        return {
            field: column.field,
            order: parsedSortExpression[sortIndex].sortData === "asc" ? 1 : -1
        };
    }, [parsedSortExpression, tableColumns]);



    const onSortSafe = (event) => {
        if (loading) {return;}

        const col = tableColumns.find((c) => c.field === event.sortField);
        if (!col || col.sortIndex === null || col.sortIndex === undefined) {
        // reset sort
            changeParsedSortExpression(-1);
        }
        else {
        // Sort with one column
            changeParsedSortExpression(col.sortIndex);
        }
    };



    const headerTemplate = (col) => {
        const isSorted = tableSort && tableSort.field === col.field;
        const arrow = isSorted ? tableSort.order === 1 ? "↑" : "↓" : "↑";

        if (!col.sortable) {
            return <span>{col.label}</span>;
        }

        return (
            <span className="PaginationHeaderGrid">
                <span className="PaginationHeaderGridLeft" />
                <span className="PaginationHeaderGridLabel">{col.label}</span>
                <span
                    className="PaginationHeaderGridArrow"
                    style={{ visibility: isSorted ? "visible" : "hidden" }}
                >
                    {arrow}
                </span>
            </span>
        );
    };





    const handleColumnResizeEnd = (event) => {
    // colonne PrimeReact (get the field)
        const field = event.column.props.field;
        const newWidth = event.element.offsetWidth; // Real width

        const colMeta = tableColumns.find((c) => c.field === field);
        if (!colMeta) {return;}

        const colId = colMeta.id;

        setPaginationType((prev) => ({
            ...prev,
            columns: prev.columns.map((pt) =>
                pt.position === colId
                    ? { ...pt, forcedwidth: `${newWidth}px` }
                    : pt
            )
        }));
    };



    const renderColumns = () =>
        tableColumns.map((col) => {
            const body = col.cellRenderer
                ? (rowData, options) =>
                    <div className={col.isActions ? "cellContentActions" : "cellContent"}>
                        {col.cellRenderer({
                            data: rowData,
                            column: { field: col.field, id: col.id },
                            tableManager: null,
                            field: col.field,
                            stringvalue: rowData[col.field],
                            colIndex: col.id,
                            rowIndex: options?.rowIndex
                        })}
                    </div>

                : (rowData) => <div className={col.isActions ? "cellContentActions" : "cellContent"}>{rowData[col.field]}</div>;


            const DEFAULT_COL_WIDTH = "220px";
            const MIN_RESIZE_WIDTH = col.minResizeWidth ? `${col.minResizeWidth}px` : "60px";
            const ACTIONS_COL_MIN_WIDTH = "120px";

            const style = col.isActions
                ? { minWidth: ACTIONS_COL_MIN_WIDTH, width: col.width } // actions
                : col.width
                    ? { width: col.width, minWidth: MIN_RESIZE_WIDTH } // largeur forcée (persistée) + min 50
                    : { width: DEFAULT_COL_WIDTH, minWidth: MIN_RESIZE_WIDTH };


            const headerClass = col.isActions
                ? "rgt-cell-header PaginationActionsHeader"
                : col.centerColumns ? "rgt-cell-header PaginationCenterHeader"
                    : "rgt-cell-header";

            const bodyClass = col.isActions
                ? "rgt-cell PaginationActionsCell"
                : col.isButton
                    ? "rgt-cell PaginationButtonCell"
                    : col.centerColumns ? "rgt-cell PaginationCenterCell"
                        : "rgt-cell";

            return (
                <Column
                    key={col.id}
                    field={col.field}
                    header={headerTemplate(col)}
                    body={body}
                    sortable={!!col.sortable}
                    resizable={!!col.resizable}
                    style={style}
                    frozen={!!col.pinned}
                    alignFrozen={col.lockRight ? "right" : undefined}
                    headerClassName={headerClass}
                    bodyClassName={bodyClass}
                />
            );
        });



    const reload = React.useCallback((currentPage, sortExpression, filterExpression, tagExpression) => {
        if (loading) {return null;}
        setLoading(true);
        onGetElements(
            currentPage,
            tpageSize,
            sortExpression,
            filterExpression,
            tagExpression,
            JSON.stringify(paginationType),
            (data) => {
                setBottomPagination(
                    data && data.results.length > 0 ? {
                        currentPage: data.currentPage ? data.currentPage : 1,
                        pageCount: data.pageCount ? data.pageCount : 1
                    } : null
                );
                if (data && data.results) {
                    setTableRows(GridTableGetRows(data.results));
                }
                setLoading(false);
            }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    React.useEffect(() => {
        if (myElements && myElements.results && !loading && tableRows) {
            setTableRows(GridTableGetRows(myElements.results));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [myElements, updateRowOnChange]);

    //we load the table header
    React.useEffect(() => {
        //setTableColumns(GridTableGetColumns());
        setTableColumns(GridTableGetColumns());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //we update the paginationType in localstate when we leave the pagination
    React.useEffect(() => {
        return () => {
            onSavePagination(JSON.stringify(paginationType));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationType]);

    const onChangePage = (value) => {
        setCurrentPage(value);
    };
    const onChangeSortExpression = (value) => {
        setSortExpression(value);
    };


    const criteriaRef = React.useRef("");
    React.useEffect(() => {
        const criteria
    = `${forcePaginationUpdate}|${sortExpression || ""}|${filterExpression || ""}|${tagExpression || ""}`;

        const criteriaChanged = criteriaRef.current !== "" && criteriaRef.current !== criteria;

        if (criteriaRef.current !== criteria) {
            criteriaRef.current = criteria;
        }

        const pageToLoad = criteriaChanged ? 1 : currentPage;

        // If change date/filters/sort/tags -> go to page 1
        if (criteriaChanged) {
            setCurrentPage(1);
            setTextFieldPage(1);
        }
        else {
            setTextFieldPage(currentPage);
        }

        reload(pageToLoad, sortExpression, filterExpression, tagExpression);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forcePaginationUpdate, currentPage, sortExpression, filterExpression, tagExpression]);


    //#region filters
    const changeParsedFilterExpression = (name, value) => {
        const parsedExpression = { ...parsedFilterExpression, [name]: value };
        setParsedFilterExpression(parsedExpression);
        onFilter(parsedExpression);
    };
    const clearFilter = () => {
        setParsedFilterExpression({});
        setParsedTagsExpression([]);
        setFilterExpression("");
        setTagsExpression("");
    };
    const onFilter = (pfilterExpression) => {

        const pfe = pfilterExpression ? pfilterExpression : parsedFilterExpression;

        let filterExpression = "";
        filterOptions.forEach(filter => {
            if (pfe[filter.filterName] && pfe[filter.filterName] !== "") {
                filterExpression += filter.filterName + ":" + pfe[filter.filterName] + ",";
            }
        });
        filterExpression !== "" ? filterExpression = filterExpression.slice(0, -1) : null;

        let tagExpression = "";
        if (parsedTagsExpression.length > 0) {
            parsedTagsExpression.forEach((tag) => {
                tagExpression += "&tagIdList=" + tag.id;
            });
            tagExpression += "&allTags=true";
        }

        setFilterExpression(filterExpression);
        setTagsExpression(tagExpression);
    };
    //#endregion

    //#region sorts
    const changeParsedSortExpression = (index) => {
        const newSort = parsedSortExpression.map((ex, i) => {
            let val = ex.sortData;
            if (i === index) {
                val = val === "asc" ? "desc" : "asc";
            }
            else {
                val = "null";
            }
            return { ...ex, sortData: val };
        });
        setParsedSortExpression(newSort);
        setPaginationType({ ...paginationType, sort: newSort });
        onChangeSortExpression(getSortExpression(newSort));
    };
    const getSortExpression = (parsedExpression) => {
        let expression = "";
        parsedExpression.forEach(ex => {
            if (ex.sortData && ex.sortData !== "null") {
                expression += ex.sortName + ":" + ex.sortData + ",";
            }
        });
        if (expression !== "") {
            expression = expression.slice(0, -1);
        }
        else {
            expression = null;
        }
        return expression;
    };
    //#endregion

    const GridTableGetColumns = () => {
        const columns = [];
        if (!tableElement || !paginationType) { return columns;}
        const rawList = tableElement(null);
        const orderedList = [...paginationType.columns]
            .sort((a, b) => a.position - b.position)
            .map(pt => ({ item: rawList[pt.teindex], forcedwidth: pt.forcedwidth, position: pt.position }));

        orderedList.forEach((orderdObject, index) => {
            const item = orderdObject.item;
            const fixedWidth = orderdObject.forcedwidth && orderdObject.forcedwidth !== "undefinedpx" ? orderdObject.forcedwidth : item && item.fixedWidth ? item.fixedWidth :
                item && item.colType === "actions" ? getActionColumnWidth(item.actions) + "px" : null;
            if (item) {
                const col = {
                    id: index,
                    field: item.colTitle,
                    label: item.colTitle,
                    minResizeWidth: 60,
                    searchable: false,
                    editable: false,
                    resizable: item.colType !== "actions",
                    sortable: item.sortIndex !== null && item.sortIndex !== undefined,
                    sortIndex: item.sortIndex,
                    sort: ({ a, b, isAscending }) => {return 0;}
                };
                if (fixedWidth) {
                    col.width = fixedWidth;
                }
                if (item.centerHeader) {
                    col.centerColumns = true;
                }
                if (item.colType === "select") {
                    col.headerCellRenderer = item.headerCellRenderer;
                }
                if (item.colType === "actions") {
                    col.pinned = true;
                    col.isActions = true;
                    col.cellRenderer = ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                        const value = data[column.field];
                        if (value) {
                            return <div style={{ width: getActionColumnWidth(item.actions) + "px", display: "flex", flexDirection: "row", gap: "10px" }}>
                                <span style={{ display: "flex" }}/>
                                { value.map((but, index) =>
                                    but ? <React.Fragment key={index}>{but}</React.Fragment> : null
                                ) }
                                <span style={{ display: "flex" }}/>
                            </div>;
                        }
                        else {return "";}
                    };
                }
                if (item.colType === "button") {
                    col.isButton = true;
                }
                if (item.cellRenderer) {
                    col.cellRenderer = item.cellRenderer;
                }
                if (item.lockRight) {
                    col.pinned = true;
                }
                columns.push(col);
            }
        });
        return columns;
    };
    const GridTableGetRows = (results) => {
        const rows = [];
        results.forEach((result, index) => {
            if (result !== null && result !== undefined) {
                const row = { id: index };
                const values = tableElement(result);
                values.forEach(value => {
                    row[value.colTitle] = value.colContent;
                });
                rows.push(row);
            }
        });
        return rows;
    };



    // For set width of action column
    const getActionColumnWidth = (actionsList) => {
        const n = actionsList.filter(a => a != null).length;
        if (n === 0) {return 0;}

        const icon = 36; // icone size
        const gap = 10; // space between action buttons
        const padding = 16; // total padding total (left + right)

        return n * icon + (n - 1) * gap + padding;
    };



    const maxWidth = 400;
    const showSearchBar = filterOptions && filterOptions.length > 0 || cardElement || tags;
    const showTableBottom = bottomPagination && bottomPagination.pageCount > 1;


    const dtTableStyle = React.useMemo(() => ({ width: "100%" }), []);
    const emptyMessage = React.useMemo(() => <NoResults />, []);
    const rowClassName = React.useCallback(() => "PaginationTableRow", []);
    const virtualScrollerOptions = React.useMemo(() => ({ itemSize: 48 }), []);
    const columns = React.useMemo(() => renderColumns(), [tableColumns, tableSort]);



    return (
        <div style={{ height: shrink ? "auto" : "100%", width: "100%", display: "flex", flexDirection: "column", overflowX: "visible" }}>
            {
                isInModal ?
                    <div className="modal-header">
                        {
                            icon ?
                                <IconComponent nameIcon={icon} color="primary-base" />
                                :
                                null
                        }
                        <span>{title ? title : ""}</span>
                        <span style={{ flexGrow: "1" }}/>
                        {
                            headerButton ?
                                headerButton.map((button, index) => {
                                    return (
                                        <ButtonSkaRound
                                            key={index}
                                            type={button.type}
                                            onClick={button.onClick}
                                            nameIcon={button.nameIcon}
                                        />
                                    );
                                })
                                :
                                null
                        }
                        {
                            headerInfo ?
                                <div className="header-info">{headerInfo }</div>
                                :
                                null
                        }
                        {
                            headerToggle ?
                                headerToggle.map((el, index) => {
                                    return (
                                        <Toggle
                                            key={index}
                                            type={el.type}
                                            name={el.name}
                                            checked={el.checked}
                                            onClick={el.onClick}
                                        />
                                    );
                                })
                                :
                                null
                        }
                    </div>
                    :
                    null
            }
            {showSearchBar ?
                <div style={{ height: "88px", width: "100%", display: "flex", flexDirection: "row", gap: "20px", marginBottom: isInModal ? "0px" : "20px" }}
                >
                    <div style={{ flexGrow: 1, height: "calc(100% - 40px)", display: "flex", flexDirection: "row", gap: "20px",
                        alignItems: "center", padding: "20px",
                        borderRadius: isInModal ? null : "6px" }}
                    >
                        <div style={{
                            flexGrow: 1, display: "flex", flexDirection: "row", gap: "20px", alignItems: "center"
                        }}>
                            {
                                filterOptions ? filterOptions.map((filter, index) => {
                                    const value = parsedFilterExpression[filter.filterName] ? parsedFilterExpression[filter.filterName] : null;
                                    switch (filter.filterType) {
                                        case "text": return <TextField
                                            key={index}
                                            maxWidth={maxWidth}
                                            placeholder={filter.title}
                                            value={value ? value : ""}
                                            onChange={(e) => {
                                                changeParsedFilterExpression(filter.filterName, e.target.value);
                                            }}
                                        />;
                                        case "select": return <Dropdown
                                            key={index}
                                            maxWidth={maxWidth}
                                            placeHolder={filter.title}
                                            emptyTitle={strings.ALL}
                                            list={filter.list}
                                            value={value ? value : null}
                                            onChange={(option) => {
                                                changeParsedFilterExpression(filter.filterName, option ? option.id : null);
                                            }}
                                        />;
                                    }
                                }) : null
                            }
                            {
                                tags ? <ChooseTags
                                    maxWidth={maxWidth}
                                    allTags={tags}
                                    elementTags={parsedTagsExpression}
                                    onChangeTags={(newList) => {
                                        setParsedTagsExpression(newList);
                                    }}
                                /> : null
                            }
                        </div>
                        {
                            isInModal ?
                                <ButtonSkaRound
                                    type={"secondary"}
                                    onClick={() => clearFilter()}
                                    nameIcon="reset"
                                />
                                :
                                <ButtonSKA
                                    type={"secondary-icon"}
                                    //isDisabled={loading}
                                    onClick={() => clearFilter()}
                                    nameIcon="reset"
                                    text={strings.clear}
                                />
                        }
                        {
                            isInModal ?
                                <ButtonSkaRound
                                    type={"primary"}
                                    onClick={() => onFilter()}
                                    nameIcon="search"
                                />
                                :
                                <ButtonSKA
                                    type="primary-icon"
                                    //isDisabled={loading}
                                    onClick={() => onFilter()}
                                    nameIcon="search"
                                    text={strings.search}
                                />
                        }
                    </div>
                    {
                        cardElement ? <Switch
                            position={showCards ? 1 : 0}
                            onChange={(position) => setShowCards(position === 1)}/> : null
                    }
                </div>
                : null
            }
            <div style={{ flexGrow: shrink ? 0 : 1, width: "100%", minWidth: 0, minHeight: 0, display: "flex", flexDirection: "column", gap: "0px", borderRadius: "10px",
                backgroundColor: showCards ? "transparent" : "var(--white)"
            }}>
                <div style={{ width: "100%", minWidth: 0, flex: 1, minHeight: 0, backgroundColor: isInModal ? "var(--white)" : "none" }}>
                    {
                        !showCards ? loading ? <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Loader dimensions="40px" />
                        </div> : <div ref={tableWrapRef} style={{ position: "relative", height: "100%", minHeight: 0, overflowY: loading ? "hidden" : "auto" }}>
                            <DataTable
                                value={tableRows}
                                dataKey="id"
                                scrollable
                                scrollHeight="flex"
                                style={{ height: "100%" }}
                                scrollDirection="both"
                                virtualScrollerOptions={virtualScrollerOptions}
                                tableStyle={dtTableStyle}
                                emptyMessage={emptyMessage}
                                className="PaginationTable"
                                rowClassName={rowClassName}
                                sortField={tableSort?.field}
                                sortOrder={tableSort?.order}
                                sortMode="single"
                                onSort={onSortSafe}
                                resizableColumns
                                columnResizeMode="fit"
                                onColumnResizeEnd={handleColumnResizeEnd}
                            >
                                {columns}
                            </DataTable>
                        </div>
                            : <div style={{ width: "100%", flexGrow: shrink ? "0" : "1", overflowY: "auto", height: "100%" }}>
                                {
                                    loading || forceLoading ? <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <Loader dimensions="40px" color={"var(--primary-base)"} />
                                    </div> : !myElements || !myElements.results || myElements.results.length <= 0 ? <div className="TextContent16" style={{ flexGrow: "1", textAlign: "center", width: "100%", marginTop: "20px", marginBottom: "20px" }}>
                                        {strings.noItems}
                                    </div> : <div style={{ display: "flex", flexGrow: "1", flexDirection: "row", flexWrap: "wrap", gap: "20px" }}>
                                        {myElements.results.map((el, index) =>
                                            <React.Fragment key={el?.id ?? el?.Id ?? el?.name ?? index}>
                                                {cardElement(el, index)}
                                            </React.Fragment>
                                        )}

                                    </div>
                                }
                            </div>
                    }
                </div>
                { // Pagination Table Bottom
                    showTableBottom ? <div className="horizontalFlexContainer PaginationTableBottom"
                        style={{ gap: "10px", borderRadius: onClose ? "0" : "0px 0px 6px 6px" }}>
                        <div className="TextContent14">{strings.goToPage}</div>
                        <input className="TextField-small-filled" type="text"
                            style={{ width: "40px", textAlign: "center", height: "26px", padding: "0px", borderRadius: "0px" }}
                            value={textfieldPage}
                            onChange={(e) => {
                                let temp = textfieldPage;
                                temp = Math.max(1, Math.min(bottomPagination.pageCount, parseInt(e.target.value)));
                                if (!isNaN(temp) && temp !== textfieldPage) {
                                    setTextFieldPage(temp);
                                }
                                else if (isNaN(temp)) {
                                    setTextFieldPage(0);
                                }
                            }}
                            onBlur={() => {
                                if (textfieldPage !== bottomPagination.currentPage) {
                                    onChangePage(textfieldPage);
                                }
                            }}/>
                        <span style={{ flexGrow: "1" }}/>
                        <ButtonSKA
                            isDisabled={bottomPagination.currentPage === 1}
                            type="pagination"
                            onClick={() => onChangePage(1)}
                            nameIcon={"leftPage"}
                        />
                        <ButtonSKA
                            isDisabled={bottomPagination.currentPage === 1}
                            type="pagination-large"
                            onClick={() => onChangePage(bottomPagination.currentPage - 1)}
                            nameIcon={"chevronLeft"}
                        />
                        <div className="TextContent14">{strings.page + " " + bottomPagination.currentPage + "/" + bottomPagination.pageCount}</div>
                        <ButtonSKA
                            isDisabled={bottomPagination.currentPage === bottomPagination.pageCount}
                            type="pagination-large"
                            onClick={() => onChangePage(bottomPagination.currentPage + 1)}
                            nameIcon={"chevronRight"}
                        />
                        <ButtonSKA
                            isDisabled={bottomPagination.currentPage === bottomPagination.pageCount}
                            type="pagination"
                            onClick={() => onChangePage(bottomPagination.pageCount)}
                            nameIcon={"rightPage"}
                        />
                        <span style={{ width: "10px" }}/>
                    </div> : null
                }
                {
                    isInModal ?
                        <div className="horizontalFlexContainer PaginationButtonCloseModal">
                            <ButtonSKA
                                type="secondary-icon"
                                onClick={onClose}
                                nameIcon="cancel"
                                text={strings.close}
                            />
                        </div> :
                        null
                }
            </div>
        </div>
    );
};

export default PaginationList;
